import { Badge, Tooltip } from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import { dateTime } from "@src/utils/formatters";
import { observer } from "mobx-react-lite";
import React from "react";

interface ArchivedBadgeProps {
  at: Date;
  by?: string;
}

const ArchivedBadge = ({ at, by }: ArchivedBadgeProps) => (
  <Tooltip
    label={
      <React.Fragment>
        {by ? (
          <Trans>
            Archived by <b>{by}</b>
          </Trans>
        ) : (
          <Trans>Archived</Trans>
        )}{" "}
        <Trans>on {dateTime.format(at)}</Trans>
      </React.Fragment>
    }
  >
    <Badge colorScheme="red">
      <Trans>Archived</Trans>
    </Badge>
  </Tooltip>
);

export default observer(ArchivedBadge);
